import { Directive, HostListener, ElementRef, Renderer2, Input } from '@angular/core';

// Service
import { SharedService } from '../services/api/message.service';

@Directive({
  selector: '[multiAnnouncement]'  // Update the selector to match the HTML attribute
})
export class MultiSelectAnnouncement {

    @Input() multiAnnouncement: any = '';  // Input property to pass values

  constructor(private el: ElementRef, private renderer: Renderer2, private sharedService: SharedService) {}

  @HostListener('focus', ['$event'])
  async onFocus(event: FocusEvent): Promise<void> {
    const [selectedVal, arrayOfVal] = this.multiAnnouncement;

    // console.log('selectedVal', selectedVal);
    // console.log('arrayOfVal', arrayOfVal);

    let selectedString: string[] = [];
    if(this.multiAnnouncement.length > 1) {
      selectedString = await this.getSelectedRoles(selectedVal, arrayOfVal);
    }else{
      selectedString = selectedVal;
    }
        
    if(selectedString){
      setTimeout(() => {
        this.sharedService.announcement.next(selectedString.join(', ') + " is selected");
      }, 100);      
    }    
  }


  // Optionally handletthe blur event (when the element loses focus)
  @HostListener('blur', ['$event'])
  onBlur(event: FocusEvent): void {    
    
    this.sharedService.announcement.next(''); 
  }


  async getSelectedRoles(selectedVal: any, arrayOfVal: any): Promise<string[]> {
    // Simulating async behavior with a delay
    return new Promise(resolve => {      
        const result = arrayOfVal
          .filter((role: any) => selectedVal.includes(role.id || role.value))
          .map((role: any) => role.title || role.name || role.full_name); // Adjust based on your data structure
        resolve(result);       
    });
  }
  
}
